export default __webpack_public_path__ + "static/media/reading-icon.d5740f016584711480912bb2ebc52ad0.png";